import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { LucideAngularModule, Facebook, Twitter, Instagram, Youtube } from 'lucide-angular';
import { companyInfo } from '../../data/mock';
import { LocalStorageService } from '../../services/local-storage.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterLink, LucideAngularModule],
      templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent {
  companyInfo = companyInfo;
  visitors: any = 0;
  constructor(private localStorage: LocalStorageService,
    public router: Router){
       this.visitors = this.localStorage.getItem('visitors');
  }
}
